import { logWrapper } from '../../utils';
import swal from 'sweetalert2';
import jQuery from 'jquery';

export default {
  trashCanController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    '$timeout',
    'revisionService',
    '$filter',
    '$state',
    '$controller',
    'searchService',
    'authService',
    'EQuickAccessItems',
    'EDocumentStatus',
    '$uibModal',
    '$location',
    '$translate',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      $timeout,
      revisionService,
      $filter,
      $state,
      $controller,
      searchService,
      authService,
      EQuickAccessItems,
      EDocumentStatus,
      uibModal,
      $location,
      $translate
    ) {
      'use strict';

      function onClearSearchTerm() {
        $scope.clearTerm();
      }

      function initializeSearchField() {
        $rootScope.displayOptions = false;

        $scope.hasSearchText = $scope.searchTerm ? true : false;
        $scope.isSelectAll = false;

        $scope.selectedFolder = null;
        $scope.options = searchService.options;
        $scope.options.query = $scope.searchTerm;

        $scope.unselectAllText = $filter('translate')('UNCHECK ALL');

        $scope.itemsFilter = function (item) {
          return (
            item.idStatus === EDocumentStatus.TRASH_CAN &&
            item.idStatus === EDocumentStatus.IN_FLOW_TRASH_CAN
          );
        };

        $scope.count = 0;
        $scope.pageCount = 1;
      }

      function goToPage(page) {
        $state.go('home.trashcan', {
          q: $scope.searchTerm,
          f: $scope.searchFields,
          p: page,
        });
      }

      function itemsFilter(item) {
        return (
          (item.idStatus === EDocumentStatus.TRASH_CAN && !item.removed) ||
          item.idStatus === 9
        );
      }

      function searchTrash() {
        if ($scope.currentPage < 1) {
          $scope.goToPage(1);
        } else {
          $rootScope.currentDocument = null;
          $scope.count = 0;

          $scope.description = 'LOADING DOCUMENTS';
          $scope.documents(null);

          $scope.loading = true;

          var folderColumn = $scope.columns.filter((c) => c.id === 'folder')[0];
          if (folderColumn !== undefined && folderColumn !== null)
            folderColumn.disabled = false;

          searchService
            .trashCanSearch(
              $scope.searchTerm,
              $scope.searchFields,
              $scope.currentPage,
              $scope.pageSize
            )
            .then(
              function (data) {
                $scope.count = data.length;

                $scope.totalItem = $scope.count;

                if ($scope.totalItem > $scope.limite) {
                  $scope.limiteValor = $scope.limite;
                  $scope.botaoAtivo = true;
                } else {
                  $scope.limiteValor = $scope.totalItem;
                  $scope.botaoAtivo = false;
                }

                $scope.pageCount = Math.ceil($scope.count / $scope.pageSize);

                $scope.loading = false;

                if ($scope.pageCount < $scope.currentPage && $scope.count > 0) {
                  $scope.goToPage($scope.pageCount);
                } else {
                  $scope.documents(data);

                  $scope.groups = [];

                  $scope.description = $scope.getDescription(
                    $scope.currentPage,
                    $scope.pageSize,
                    $scope.count
                  );

                  $scope.noDocuments = $filter('translate')('NO RESULTS FOUND');
                  $scope.noDocumentsMessage = $filter('translate')(
                    'NO RESULTS FOUND MSG'
                  );
                }
              })
              .catch(() => {
                $scope.documents([]);

                $scope.modalRemoveDocument = uibModal.open({
                  scope: $scope,
                  animationEnabled: true,
                  backdrop: 'static',
                  templateUrl: '/views/modal/errorModal/errorModal.html',
                  controller: 'trashCanController',
                  backdrop: 'static',
                  keyboard: true,
                  size: 'm',
                });
              });
        }
      }

      function closeOptions() {
        $rootScope.displayOptions = false;
      }

      function toggleOptions() {
        $rootScope.displayOptions = !$rootScope.displayOptions;
        jQuery('#search-options').focus();
      }

      function showOptions() {
        $rootScope.displayOptions = true;
      }

      function queryTextChange() {
        $scope.hasSearchText = $scope.options.query.length > 0;
      }

      function searchKeyPress(event) {
        if (event.which === 13) {
          $scope.doSearch();
        }
      }

      function clearSearch() {
        clearTerm();
        closeSearch();
        loadDocuments();
      }

      function clearTerm() {
        $scope.options = searchService.options;
        $scope.options.query = '';

        $scope.hasSearchText = false;

        $rootScope.displayOptions = false;
      }

      function closeSearch() {
        $rootScope.$broadcast('closeSearch');
      }

      function verifyIsAllSelected() {
        var isAllSelected = true;

        for (var o in $scope.options) {
          if (
            typeof $scope.options[o] === 'boolean' &&
            $scope.options[o] === false
          ) {
            isAllSelected = false;
            break;
          }
        }

        $scope.unselectAllText = isAllSelected
          ? $filter('translate')('UNCHECK ALL')
          : $filter('translate')('CHECK ALL');
        $scope.isSelectAll = !isAllSelected;
      }

      function unselectAll() {
        $scope.options.code = $scope.isSelectAll;
        $scope.options.additionalFields = $scope.isSelectAll;
        $scope.options.title = $scope.isSelectAll;
        $scope.options.author = $scope.isSelectAll;
        $scope.options.documentType = $scope.isSelectAll;
        $scope.options.revisionDate = $scope.isSelectAll;
        $scope.options.description = $scope.isSelectAll;
        $scope.options.extension = $scope.isSelectAll;
        $scope.options.keywords = $scope.isSelectAll;
        $scope.options.folder = $scope.isSelectAll;

        $scope.unselectAllText = $scope.isSelectAll
          ? $filter('translate')('UNCHECK ALL')
          : $filter('translate')('CHECK ALL');
        $scope.isSelectAll = !$scope.isSelectAll;
      }

      function optionChanged() {
        $scope.getSearchFields();
        if (
          $scope.options.query !== '' &&
          ($scope.getSearchFields().length > 0 ||
            $scope.options.searchOnContent)
        ) {
          $scope.doSearch();
        }
      }

      function doSearch() {
        if ($scope.options.query === '') {
          swal.fire(
            $filter('translate')('SEARCH EMPTY'),
            $filter('translate')('SEARCH EMPTY'),
            'warning'
          );
          return;
        }

        var searchFields = $scope.getSearchFields();

        if (
          searchFields.length === 0 &&
          ($scope.options.searchOnContent === null ||
            $scope.options.searchOnContent === false)
        ) {
          swal.fire(
            $filter('translate')('SELECT FIELDS'),
            $filter('translate')('SELECT FIELDS'),
            'warning'
          );
          $rootScope.displayOptions = true;
          return;
        }

        if ($scope.selectedFolder !== null && $scope.selectedFolder.Id < 0) {
          $scope.options.folderFilter = 0;
        }

        searchService.searchParams.SearchTerm = $scope.options.query;
        searchService.searchParams.SearchFields = searchFields;
        searchService.searchParams.StartIndex = 0;
        searchService.searchParams.PageCount = 50;
        searchService.searchParams.AllFolders =
          parseInt($scope.options.folderFilter) === 0;
        searchService.searchParams.ThisFolder =
          parseInt($scope.options.folderFilter) === 1;
        searchService.searchParams.SubFolders =
          parseInt($scope.options.folderFilter) === 2;

        if ($scope.options.folderFilter !== 0) {
          searchService.searchParams.selectedFolder = $scope.selectedFolder;
        } else {
          searchService.searchParams.selectedFolder = undefined;
        }

        $rootScope.displayOptions = false;

        $state.go('home.trashcan', {
          q: $scope.options.query,
          p: 1,
          f: searchFields.join([';']),
        });
      }

      function getSearchFields() {
        var searchFields = [];

        var fields = [
          'code',
          'additionalFields',
          'title',
          'author',
          'documentType',
          'revisionDate',
          'description',
          'extension',
          'keywords',
          'folder',
          'searchOnContent',
          'isExactSearch',
        ];

        for (var o in $scope.options) {
          if ($scope.options.hasOwnProperty(o)) {
            var i = fields.indexOf(o);
            if (i > -1) {
              var field = fields[i];

              if (field === 'keywords') {
                field = 'keyWords';
              } else if (field === 'searchOnContent') {
                field = 'content';
              }

              if ($scope.options[o] === true) {
                searchFields.push(field);
              }
            }
          }
        }

        $scope.searchTrash();
        return searchFields;
      }

      function carregaMais() {
        if ($scope.currentPage >= $scope.pageCount)
          return;

        $scope.currentPage++;
        $scope.loading = true;

        revisionService
          .loadRevisionsTrashcan($scope.currentPage, $scope.pageSize)
          .then((data) => {

            $scope.totalItem = data.count;

            var docs = $scope.documents();

            Array.prototype.push.apply(docs, data.items);

            $scope.count = docs.length;

            $scope.pageCount = Math.ceil(
              $scope.totalItem / $scope.pageSize
            );

            $scope.limiteValor = $scope.count;

            $scope.description = $scope.getDescription(
              $scope.currentPage,
              $scope.pageSize,
              $scope.totalItem,
              $scope.count
            );

            $scope.loading = false;
          })
          .catch(() => {
            $scope.loading = false;
          });
      }


      function loadDocuments() {
        if ($scope.currentPage < 1) {
          $scope.currentPage = 1;
        }

        $rootScope.currentDocument = null;

        $scope.count = 0;
        $scope.totalItem = 0;
        $scope.pageCount = 0;

        $scope.documents([]);
        $scope.groups = [];

        $scope.loading = true;

        var folderColumn = $scope.columns.filter((c) => c.id === 'folder')[0];
        if (folderColumn) {
          folderColumn.disabled = true;
        }

        revisionService.cancelLoadRevisions();

        $rootScope.$broadcast('loadFolder', EQuickAccessItems.TRASHCAN);

        revisionService
          .loadRevisionsTrashcan($scope.currentPage, $scope.pageSize)
          .then((data) => {
            $scope.totalItem = data.count;
            $scope.count = data.items.length;
            $scope.documents(data.items);

            $scope.pageCount = Math.ceil(
              $scope.totalItem / $scope.pageSize
            );

            if ($scope.totalItem > $scope.count) {
              $scope.limiteValor = Math.min($scope.limite, $scope.totalItem);
              $scope.botaoAtivo = true;
            } else {
              $scope.limiteValor = $scope.totalItem;
              $scope.botaoAtivo = false;
            }

            $scope.loading = false;

            authService.getUserAsync().then(user => {
              user.userPreferences.IdLastFolder = EQuickAccessItems.TRASHCAN;
            });

            if (authService.authentication.email !== 'autologin') {
              var date = $scope.columns.filter((c) => c.id === 'date')[0];
              date.sorted = 'asc';
              $scope.sortColumn(date);
            } else {
              var title = $scope.columns.filter((c) => c.id === 'title')[0];
              title.sorted = '';
              $scope.sortColumn(title);
            }

            $scope.description = $scope.getDescription(
              $scope.currentPage,
              $scope.pageSize,
              $scope.totalItem,
              $scope.count
            );
          })
          .catch(() => {

            $scope.documents([]);
            $scope.loading = false;

            $scope.modalRemoveDocument = uibModal.open({
              animationEnabled: true,
              backdrop: 'static',
              templateUrl: '/views/modal/errorModal/errorModal.html',
              controller: 'trashCanController',
              keyboard: true,
              size: 'm',
            });
          });
      }

      function deleteModel() {
        revisionService
          .emptyRevisionsTrashcan()
          .then((result) => {
            $scope.modalEmptyTrash.close();

            $scope.loadDocuments();

            var message = $translate.instant('TRASHCLEAN_SUCCESS_TEXT', { mb: result.Megabytes });

            swal.fire({
              title: $filter('translate')('FREE-FLOWING TRASH CAN'),
              text: message,
              showConfirmButton: true,
              allowEscapeKey: false,
              allowOutsideClick: false,
              icon: 'success',
            });
          })
          .catch(() => {
            swal.fire({
              title: $filter('translate')('AN ERROR OCCURRED'),
              text: $filter('translate')('AN ERROR OCCURRED WHILE DELETING ALL DOCUMENTS FROM THE TRASH. PLEASE TRY AGAIN LATER.'),
              icon: 'error',
              confirmButtonText: $filter('translate')('OK')
            });

            $scope.modalEmptyTrash.close();
          });
      }

      function cancelButton() {
        if ($scope.modalEmptyTrash) {
          $scope.modalEmptyTrash.close();
        }
      }

      function configColumnsTrashCan() {
        $scope.columns = [
          {
            id: 'icon',
            width: '50',
            header: $filter('translate')('COLUMN.ICON'),
            expression: 'getIcon()',
            tooltip: 'extension',
            style: {
              padding: '10px 10px 10px 26px',
              'text-overflow': 'clip',
              'max-width': '50px'
            },
            hideHeader: true,
            visible: true,
            disabled: false,
            dataPriority: 1
          },
          {
            id: 'status',
            width: '30',
            header: $filter('translate')('COLUMN.STATUSICON'),
            expression: 'getStatusIcon()',
            tooltip: 'getStatus()',
            style: {
              padding: '10px',
              'text-overflow': 'clip',
              'max-width': '30px'
            },
            dataPriority: 7,
            hideHeader: true,
            visible: false,
            disabled: false
          },
          {
            id: 'code',
            //width: '75',
            header: $filter('translate')('COLUMN.CODE'),
            style: {
              'min-width': '75px'
            },
            expression: 'code',
            sortExpression: 'code',
            mobileShow: false,
            dataPriority: 3,
            visible: false,
            disabled: false,
            sortable: true,
            type: 'text'
          },
          {
            id: 'title',
            width: '150',
            header: $filter('translate')('COLUMN.TITLE'),
            expression: 'title',
            style: {
              'min-width': '150px'
            },
            sortExpression: 'title',
            tooltip: 'tooltipTitle()',
            dataPriority: 1,
            visible: true,
            disabled: false,
            sortable: true,
            type: 'text'
          },
          {
            id: 'description',
            //width: '150',
            header: $filter('translate')('COLUMN.DESCRIPTION'),
            expression: 'formatedDescription()',
            style: {
              'min-width': '150px',
              'max-width': '600px'
            },
            sortExpression: 'description',
            tooltip: 'tooltipDescription()',
            visible: false,
            dataPriority: 7,
            disabled: false,
            mobileShow: false,
            sortable: true,
            type: 'text'
          },
          {
            id: 'size',
            //width: '100',
            header: $filter('translate')('COLUMN.SIZE'),
            expression: 'formatedSize()',
            sortExpression: 'size',
            style: {
              'min-width': '100px'
            },
            mobileShow: false,
            visible: true,
            dataPriority: 7,
            disabled: false,
            sortable: true,
            type: 'number'
          },
          {
            id: 'rev',
            width: '65',
            header: $filter('translate')('COLUMN.REVNUMBER'),
            style: {
              'min-width': '65px'
            },
            expression: 'revisionNumber',
            visible: false,
            disabled: false,
            dataPriority: 6,
            mobileShow: false,
            sortable: true,
            type: 'number'
          },
          {
            id: 'author',
            //width: '80',
            header: $filter('translate')('COLUMN.AUTHOR'),
            expression: 'author.Name',
            style: {
              'min-width': '80px'
            },
            mobileShow: false,
            visible: true,
            dataPriority: 7,
            disabled: false,
            sortable: true,
            type: 'text'
          },
          {
            id: 'date',
            header: $filter('translate')('COLUMN.DATE'),
            //width: '85',
            expression: 'formatedDate()',
            sortExpression: 'date',
            style: {
              'min-width': '85px'
            },
            mobileShow: false,
            visible: false,
            dataPriority: 6,
            disabled: false,
            sortable: true,
            type: 'date'
          },
          {
            id: 'document type',
            //width: '110',
            header: $filter('translate')('COLUMN.DOCTYPE'),
            expression: 'formatedDocumentType()',
            style: {
              'min-width': '130px'
            },
            tooltip: 'documentType.Name',
            dataPriority: 6,
            mobileShow: false,
            visible: true,
            disabled: false,
            sortable: true,
            type: 'text'
          },
          {
            id: 'trash date',
            //width: '110',
            header: $filter('translate')('COLUMN.TRASHDATE'),
            expression: 'formatedTrashDate()',
            sortExpression: 'trashDate',
            style: {
              'min-width': '85px'
            },
            dataPriority: 3,
            mobileShow: false,
            visible: true,
            disabled: false,
            sortable: true,
            type: 'date'
          },
          {
            id: 'trash user',
            //width: '110',
            header: $filter('translate')('COLUMN.TRASHUSER'),
            expression: 'trashUser.name',
            style: {
              'min-width': '100px'
            },
            dataPriority: 3,
            mobileShow: false,
            visible: true,
            disabled: false,
            sortable: true,
            type: 'text'
          }
        ];
      }

      function run() {
        try {
          $controller('baseController', { $scope: $scope });
          $controller('chatbotController', { $scope: $scope });

          $rootScope.$broadcast('earSearchTerm');
          $scope.autologincolumns = ['icon', 'title', 'description'];
          $scope.isTrashCan = true;
          $scope.title = $filter('translate')('TRASHCAN');
          $scope.description = '';
          $scope.noDocuments = $filter('translate')('NO TRASHCAN');
          $scope.noDocumentsMessage = $filter('translate')('NO TRASHCAN MSG');
          $scope.currentPage = $state.params.page
            ? parseInt($state.params.page)
            : 1;
          $scope.pageSize = 100;
          $scope.searchTerm = $state.params.q;
          $scope.searchFields = $state.params.f;
          $scope.pageCount = 1;
          $scope.groups = null;
          $scope.currentGroup = null;
          $scope.columns = [];
          $scope.canView = false;
          $scope.loading = true;
          $scope.count = 0;

          $scope.messageTitle = $filter('translate')('TRASHCAN');

          if ($scope.modalEmptyTrash) {
            $scope.messageDescription = $filter('translate')(
              'DO YOU WANT TO DELETE ALL DOCUMENTS FROM THE TRASH?'
            );
          } else {
            $scope.messageDescription = $filter('translate')(
              'FAILED TO FETCHER DOCUMENTS FROM TRASH'
            );
          }
          $scope.messageCancel = 'OK';

          initializeSearchField();

          $rootScope.$on(
            'clearSearchTerm',
            logWrapper(
              onClearSearchTerm,
              runtimeConstant.isDebugControllersInternals
            )
          );
          $scope.initializeSearchField = logWrapper(
            initializeSearchField,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.goToPage = logWrapper(
            goToPage,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.itemsFilter = logWrapper(
            itemsFilter,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.searchTrash = logWrapper(
            searchTrash,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.closeOptions = logWrapper(
            closeOptions,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.toggleOptions = logWrapper(
            toggleOptions,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.showOptions = logWrapper(
            showOptions,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.queryTextChange = logWrapper(
            queryTextChange,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.searchKeyPress = logWrapper(
            searchKeyPress,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.clearSearch = logWrapper(
            clearSearch,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.clearTerm = logWrapper(
            clearTerm,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.closeSearch = logWrapper(
            closeSearch,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.verifyIsAllSelected = logWrapper(
            verifyIsAllSelected,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.unselectAll = logWrapper(
            unselectAll,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.optionChanged = logWrapper(
            optionChanged,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.doSearch = logWrapper(
            doSearch,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getSearchFields = logWrapper(
            getSearchFields,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.carregaMais = logWrapper(
            carregaMais,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadDocuments = logWrapper(
            loadDocuments,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.deleteModel = logWrapper(
            deleteModel,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancelButton = logWrapper(
            cancelButton,
            runtimeConstant.isDebugControllersInternals
          );

          configColumnsTrashCan();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
